import { BUSINESS_COMPLETE_SOLUTIONS } from "network/endpoints";
import ewbApi from "network/ewbApi";

export default {
  getCompleteBusinessBanner: () =>
    ewbApi.get(BUSINESS_COMPLETE_SOLUTIONS.completebusinessbanner),
  getBusinessCompleteSolution: () =>
    ewbApi.get(BUSINESS_COMPLETE_SOLUTIONS. completebusinessSolution)
};
